import { render, staticRenderFns } from "./ProductStorageLocation.vue?vue&type=template&id=b01bd388&scoped=true"
import script from "./ProductStorageLocation.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductStorageLocation.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01bd388",
  null
  
)

export default component.exports